import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

// category images
import leftBrainTopImgTitle from '../../images/Seeding Brains UI/LOGO16.png'
import businessManagementImg from '../../images/Seeding Brains UI/Business Mnagement-01.png'
import healthAndSocialImg from '../../images/Seeding Brains UI/Health and social care-01.png'
import projectManagementImg from '../../images/Seeding Brains UI/Project Mnagement-01.png'
import pythonProgrammingImg from '../../images/Seeding Brains UI/PUTHON PROGRAMMING-01.png'
import riskManagementImg from '../../images/Seeding Brains UI/Risk Management-01.png'
import itComputingImg from '../../images/Seeding Brains UI/It Computing-01.png'
import brainRightImg from '../../images/Seeding Brains UI/right.png'

import classes from './BrainRight.module.css'
import { Image } from 'react-bootstrap'

const BrainRight = () => {
  const navigate = useNavigate()

  const navigateTo = (url) => {
    navigate(url)
  }

  return (
    <div className={classes.rightBrainContainer}>
      <div className={classes.rightBrainImgContainer}>
        <Image src={brainRightImg} className={classes.rightBrainImg} alt='' />
        <div
          className={`${classes.positionAbsolute} ${classes.opacity} opacity-right ${classes.rightBrainTopTitle} rightBrainTopTitle`}
        >
          <Image src={leftBrainTopImgTitle} style={{ width: 190 }} alt='' />
        </div>
        <div
          className={`${classes.positionAbsolute} ${classes.opacity} opacity-right ${classes.businessManagementImgContainer} businessManagementImgContainer`}
        >
          <Link to='/category/business-management'>
            <Image
              src={businessManagementImg}
              style={{ padding: 20 }}
              className={classes.imgWidth180}
              alt=''
            />
          </Link>
        </div>
        <div
          className={`${classes.positionAbsolute} ${classes.opacity} opacity-right ${classes.projectManagementImgContainer} projectManagementImgContainer`}
        >
          <Link to='/category/project-management'>
            <Image
              src={projectManagementImg}
              className={classes.imgWidth180}
              alt=''
            />
          </Link>
        </div>
        <div
          className={`${classes.positionAbsolute} ${classes.opacity} opacity-right ${classes.pythonProgrammingImgContainer} pythonProgrammingImgContainer`}
        >
          <Link to='/category/python-programming'>
            <Image
              src={pythonProgrammingImg}
              className={classes.imgWidth180}
              alt=''
            />
          </Link>
        </div>
        <div
          className={`${classes.positionAbsolute} ${classes.opacity} opacity-right ${classes.riskManagementImgContainer} riskManagementImgContainer`}
        >
          <Link to='/category/risk-management'>
            <Image
              src={riskManagementImg}
              className={classes.imgWidth180}
              alt=''
            />
          </Link>
        </div>
        <div
          className={`${classes.positionAbsolute} ${classes.opacity} opacity-right ${classes.itComputingImgContainer} itComputingImgContainer`}
        >
          <Link to='/category/it-computing-rsd'>
            <Image
              src={itComputingImg}
              className={classes.imgWidth180}
              alt=''
            />
          </Link>
        </div>
        <div
          className={`${classes.positionAbsolute} ${classes.opacity} opacity-right ${classes.healthAndSocialImgContainer} healthAndSocialImgContainer`}
        >
          <Link to='/category/healt-and-social-care'>
            <Image
              src={healthAndSocialImg}
              className={classes.imgWidth180}
              alt=''
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BrainRight
